import { translate } from '@/i18n';
import { DeviceDetector } from '@/utils/device-detector';
import { getLocale } from '@/main';

function isRuDomain() {
  return getLocale() === 'ru';
}

export function storeLogos() {
  return [
    {
      alt: `${translate('body.apps.downloadIn')} Apple Store`,
      src: translate('body.apps.iosImage'),
      url: 'https://apps.apple.com/ru/app/bork/id1411917010',
      isClickable: true,
      isHiddenInMobile: !DeviceDetector.isIos()
    },
    {
      alt: `${translate('body.apps.downloadIn')} Google Play`,
      src: translate('body.apps.androidImage'),
      url: 'https://play.google.com/store/apps/details?id=com.syncleoiot.bork&hl=ru',
      isClickable: DeviceDetector.isMobile() || !isRuDomain(),
      isHiddenInMobile: DeviceDetector.isIos()
    }
  ];
}
